
export const text_eng = [
    //0
    'FA.Unit&USDT Exchange',
    //1
    'How it works',
    //2
    'Copyright 2017-2020 © N.KRAT Group AG, All rights reserved.',
    //3
    'Make a request',
    //4
    'Your Email in Fridn System',
    //5
    'Your password',
    //6
    'Exchange type',
    //7
    'Your USDT wallet',
    //8
    'Readme! Use your personal wallet',
    //9
    'USDT wallet',
    //10
    'How many FA.Unit do you want to exchage?',
    //11
    'Amount of FA.Unit',
    //12
    'I read terms end conditions',
    //13
    'Discord',
    //14
    'Next',
    //15
    'Exchange',
    //16
    'How it works',
    //17
    'Fridn USDT wallet for exchange, which will be used for transfer',
    //18
    'Send the amount to receive FA.Unit from the address of receipt of the USDT wallet, whereas 1 USDT = 1 FA.Unit',
    //19
    'After the funds receipt from that wallet, the system automatically will charge FA.Unit on said account',
    //20
    'FA.Unit commission fee is 0%',
    //21
    'Ethereum commission fee is taken over by the addresser',
    //22
    'In 2 hours from the USDT receipts FA.Unit will be credited',
    //23
    ' FA.Unit minimum amount for transfer is 10.00 USDT',
    //24
    'Readme!',
    //25
    '- The system automatically connected with wallet, that have been used earlier, with your account in Fridn system',
    //26
    '- After the funds receipt from that wallet, the system automatically will charge FA.Unit on said account',
    //27
    '- If you want to use for payment another wallet, you should register it again by filing data-form https://fridn.io/usdt_exchange/',
    //28
    '- The commission fee from the other USDT wallet will be 12% from the credited amount',
    //29
    'To go further to fridn.com, you should copy wallet system by means of clicking on “Copy” in USDT wallet gap',
    //30
    'Go to fridn.com',
    //31
    'You transferred the mentioned amount of FA.Unit from your account to the system’s operator address',
    //32
    ' Fridn system automatically handles with requests for USDT transfer',
    //33
    'USDT commission fee is 3% + Ethereum blockchain fee',
    //34
    ' Request execution to Ethereum blockchain for USDT transfer lasts within 30 minutes since FA.Unit was credited to the wallet. The time of USDT crediting depends on Ethereum net and can take up to 2 hours',
    //35
    'USDT will be transferred to the wallet you mentioned in the application. Fridn is not responsible for the incorrectly typed data and transactions cannot be recalled',
    //36
    '',
    //37
    'Get FA.Unit (USDT-->FA.Unit), 0 fee%',
    //38
    'Get USDT (FA.Unit-->USDT), 3%  Fridn fee + Ethereum fee',
    //39
    'You are successfully registered to transfer USDT to FA.Unit',
    //40
    'You already registered this USDT wallet',
    //41
    'Confirmation',
    //42
    'starting new registration',
    //43
    'starting new transaction',
    //44
    'Cancel',
    //45
    'Continue',
    //46
    'Please confirm that you agree',
    //47
    'Ethereum transaction fee depends on workload of the Ethereum website. If you want to get your amount with less comission fee, you should retry the transaction later or in other time, for example, in the evening or early morning, when Average transaction fee (ETH) is lower, than by day. If the size of the commission suits you, click on the "Continue"',
    //48
    'Ethereum commission',
    //49
    'You will be credited',
];
